
import axios from 'axios';
import { Message } from 'element-ui';
import { getUser, getToken } from '../api/user'

axios.interceptors.request.use(
    config => {
        let token = getToken();
        token && (config.headers.token = token);
        return config;
    },
    error => {
        return Promise.error(error);
    }
);
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data.status != 200) {
                Message({
                    message: response.data.message,
                    type: 'error'
                });
            }
        }
        return Promise.resolve(response);
    },
    error => {
    }
);
